module.exports = __webpack_public_path__ + "static/media/forms.1ebad451.svg";